// Copyright (c) Laserfiche.
// Licensed under the MIT License. See LICENSE in the project root for license information.

import { Component } from '@angular/core';

@Component({
  selector: 'app-lf-field-documentation',
  templateUrl: './lf-field-documentation.component.html',
  styleUrls: ['./lf-field-documentation.component.css', './../app.component.css'],
  standalone: true,
  imports: [],
})
export class LfFieldDocumentationComponent {}
